import { render } from "./resultTest.vue?vue&type=template&id=1dcae9bd&ref=fullscreenElement"
import script from "./resultTest.vue?vue&type=script&lang=ts"
export * from "./resultTest.vue?vue&type=script&lang=ts"
script.render = render

export default script